// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"348":"05cca3c0a89c57f7a9ee","411":"01c09e090d8eed15b395","535":"12d71f2a7e8f35c9b8fe"}[chunkId] + ".js";
};